import React from 'react';

export default function TextareaWithCounter({
  id,
  value,
  onChange,
  placeholder,
  minLength,
  maxLength,
  rows = 4,
  className = ''
}) {
  const text = typeof value === 'string' ? value : '';
  const charCount = text.length;

  const inRange = (() => {
    if (typeof minLength === 'number' && charCount < minLength) return false;
    if (typeof maxLength === 'number' && charCount > maxLength) return false;
    return true;
  })();

  const borderClass = 'border-lightGrey';
  const counterClass = inRange ? 'text-gray' : 'text-[#F04438]';

  return (
    <div className="relative">
      <textarea
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        rows={rows}
        className={`w-full rounded-[10px] border-1p3 px-4 xl:py-3 py-2 text-base resize-none ${borderClass} ${className}`}
      />
      {typeof maxLength === 'number' ? (
        <span className={`absolute right-3 bottom-2 text-xs font-medium ${counterClass}`}>
          {charCount}/{maxLength}
        </span>
      ) : (
        <span className={`absolute right-3 bottom-2 text-xs font-medium ${counterClass}`}>
          {charCount}
        </span>
      )}
    </div>
  );
}
